import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-Launch',
  subtitle: 'View Go Live checklist data and set the post-launch screening date.',
  go_live_checklist: {
    labels: {
      yes: 'Yes',
      no: 'No',
    },
    title: 'Go Live Checklist',
    form: {
      is_google_business_available: {
        label: 'Google Business available',
      },
      is_smart_pricing_configured: {
        label: 'Cheaper prices than Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Promo Flyer sent',
      },
      is_menu_fully_configured: {
        label: 'All menu items available',
      },
      has_offers_on_competitor_platforms: {
        label: 'Does the restaurant has offers running on Wolt, Uber, Lieferando (except free delivery offer)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram story shared with owner',
      },
      is_order_system_connected_to_website: {
        label: 'Foodamigos Website connected OR Restaurant own Website Online Order button added',
      },
      google_business_connected_by: {
        label: 'How did we gain access to Google Business Profile?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Sales manager invited google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Sales manager sent the first request themself from the owner Phone',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Onboarding manager requested google business profile (SM did not invite & did not request access)',
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Save',
    },
    toasts: {
      success: 'Successfully saved',
      error: 'Failed to save',
    },
  },
  post_launch_screening: {
    title: 'Post-Launch Screening',
    form: {
      screening_date: {
        label: 'Screening Date',
      },
    },
    toasts: {
      success: 'Successfully saved',
      error: 'Failed to save',
    },
    buttons: {
      save: 'Save',
    },
  },
};
